/* esm.sh - style-to-object@1.0.14 */
export * from "/*style-to-object@1.0.14/esnext/style-to-object.mjs";
export { default } from "/*style-to-object@1.0.14/esnext/style-to-object.mjs";
